import type { CarSpec } from 'noddi-types';
import { CarImage, FleetCarSelectionButton } from 'noddi-web';
import { getCarName } from '../../../../utils/carName';

type Props = {
  /** The booking draft's car, which carries the display name and model family image. */
  car: CarSpec | undefined;
  licensePlateNumber: string;
  isSelected: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  price: string;
};

/** One car's row in a multi-car pick, named and pictured as on the car step. */
export const BookingCarSelectionButton = ({ car, licensePlateNumber, isSelected, onClick, price }: Props) => (
  <FleetCarSelectionButton
    isSelected={isSelected}
    onClick={onClick}
    carName={car && getCarName({ car })}
    // Shrunk from the thumbnail's 40px so the row stays close to one line high.
    image={car && <CarImage car={car} alt='' size='thumbnail' className='h-8 w-12' />}
    licensePlateNumber={licensePlateNumber}
    price={price}
  />
);
